import React from "react";
import SponsorLayer from "./SponsorLayer";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";


const SponsorPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Sponsors" />

        {/* AlertLayer */}
        <SponsorLayer />

      </MasterLayout>
    </>
  );
};

export default SponsorPage;
